import React, { Component } from 'react'
import "./css/IntroContainer.css"
import { Container, Row, Col } from 'react-bootstrap'

export default class IntroContainer extends Component {
        render() {
                return (
                        <Container style={{width: "75%"}} id="illustration-intro">
                                <Row>
                                        <Col lg={6} md={12} align="center">
                                                <img id="image-intro-kid" src="/images/HomePage/intro.png" alt="intro 3d"></img>
                                        </Col>
                                        <Col lg={6} md={12} align="center">
                                                <div className="info-heading mt-5">AN EXPLORATORY DATA ANALYSIS TOOL FOR DATA SCIENTISTS</div>
                                                <p className="info-text-normal" >Welcome at <label className="font-weight-bold">ANALYZE IT!</label></p>
                                                <p className="info-text-normal" >A platform where you can perform several operations on your datasets without the knowledge of any programming language.</p>
                                        </Col>
                                </Row>
                        </Container>
                )
        }
}
